<template>
    <div id="c2cOrder">
        <Header title="购买订单" :show-back="true" class="header"></Header>
        <img src="../../assets/img/c2c/c2cBg.png" alt="" class="bgImg"/>
        <div class="content">
            <!--顶部-->
            <div class="topWrap">
                <div>
                    <span>{{orderObj.real_name}}</span>
                    <span>备注码 {{orderObj.remark}}</span>
                </div>
                <img src="../../assets/img/c2c/CHAHH@2x.png" alt=""/>
            </div>
            <!--信息-->
            <ul class="orderInfo">
                <li class="infoList">
                    <div class="left">
                        <span>订单号:</span>
                        <span>{{orderObj.id}}</span>
                    </div>
                    <div class="type padding">{{orderObj.status_info}}</div>
                </li>
                <li class="infoList">
                    <div class="left">
                        <span>价格:</span>
                        <span>{{orderObj.price}} RMB/USDT</span>
                    </div>
                    <div class="type"></div>
                </li>
                <li class="infoList">
                    <div class="left">
                        <span>数量:</span>
                        <span>{{orderObj.num}} USDT</span>
                    </div>
                    <div class="type"></div>
                </li>
                <li class="infoList">
                    <div class="left">
                        <span>总额:</span>
                        <span></span>
                    </div>
                    <div class="type success">{{orderObj.price * orderObj.num}} RMB</div>
                </li>
            </ul>
            <!--支付方式-->
            <div @click="showPayType=true">
                <!-- 银联 -->
                <div class="payType" v-if="orderObj.bank && radio === 1">
                    <img src="../../assets/img/c2c/c2cBg.png" alt="">
                    <div>
                        <span>{{orderObj.real_name}} {{orderObj.bank.bankcard}}</span>
                        <span>{{orderObj.bank.bank}}</span>
                    </div>
                </div>
                <!-- 支付宝 -->
                <div class="payType" v-if="orderObj.alipay && radio === 2">
                    <img src="../../assets/img/c2c/c2cBg.png" alt="">
                    <div>
                        <span>{{orderObj.real_name}} {{orderObj.alipay.alipay}}</span>
                    </div>
                </div>
                <!-- 微信 -->
                <div class="payType" v-if="orderObj.weixin&& radio === 3">
                    <img src="../../assets/img/c2c/c2cBg.png" alt="">
                    <div>
                        <span>{{orderObj.real_name}} {{orderObj.weixin.weixin}}</span>
                    </div>
                </div>
            </div>
            <!--备注码-->
            <div class="codeBox">
                <span>付款时请填写备注码</span>
                <span>{{orderObj.remark}}</span>
            </div>
            <!--提示-->
            <div class="topicBox">
                <div class="title">交易提示：</div>
                <div class="topicList">
                    <p>
                        1、您的汇款将直接进入卖方的账户，交易过程中卖方出售 的数字资产由平台托管保护。
                    </p>
                    <p>
                        2、请在30分钟内完成付款，并务必点击 “我已付款”，卖 方确认收款后，系统会将数字资产划转到您的账户。 <span>超过30分钟未点击 “我已付款”，订单将自动撤销。</span>
                    </p>
                    <p>
                        3、买方或广告方当日连续取消3笔订单，会限制当天的买入功能。查看详细交易规则。
                    </p>
                    <p>
                        4、点击【我已付款】30分钟后，对方一直未放行的，可进行申述。
                    </p>
                </div>
            </div>
        </div>
        <!--底部-->
        <div class="footBox">
            <div class="left">
                <div @click="showPhoneNum">
                    <img src="../../assets/img/c2c/phone.png" alt=""/>
                    <span>联系对方</span>
                </div>
                <div @click="toMsgPage">
                    <img src="../../assets/img/c2c/message.png" alt=""/>
                    <span>聊天</span>
                </div>
            </div>
            <!-- 16 种按钮状态 -->
            <div class="right" v-if="orderObj.buy_type === 131">
                <button class="success" @click="readyPay">我已付款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 141">
                <button class="cancel" disabled>申诉</button>
                <button class="cancel" disabled>确认收款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 142">
                <button class="cancel" disabled>申诉</button>
                <button class="cancel" disabled>确认收款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 132">
                <button @click="show=true">取消订单</button>
                <button class="success" @click="readyPay">我已付款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 231">
                <button class="success">等待放行</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 241">
                <button class="success" @click="toComplain">申诉</button>
                <button class="success" @click="confirmPay">确认收款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 242">
                <button class="success" @click="toComplain">申诉</button>
                <button class="success" @click="confirmPay">确认收款</button>
            </div>
            <div class="right" v-if="orderObj.buy_type === 232">
                <button class="success">等待放行</button>
            </div>
            <div class="right"
                 v-if="orderObj.buy_type === 331 ||
                 orderObj.buy_type === 341 ||
                 orderObj.buy_type === 332||
                 orderObj.buy_type === 342">
                <button class="success" @click="toComplete">已完成</button>
            </div>
            <div class="right"
                 v-if="orderObj.buy_type === 431 ||
                 orderObj.buy_type === 441 ||
                 orderObj.buy_type === 432||
                 orderObj.buy_type === 442">
                <button class="success">申诉中</button>
            </div>
            <div class="right"
                 v-if="orderObj.buy_type === -131 ||
                 orderObj.buy_type === -141 ||
                 orderObj.buy_type === -132||
                 orderObj.buy_type === -142">
                <button class="cancel">已撤销</button>
            </div>
        </div>
        <!--取消订单弹框-->
        <van-dialog v-model="show" title="取消订单" @confirm="cancelOrderEvent"
                    show-cancel-button confirmButtonColor="#1FC26D">
            <div class="cancelAlert">
                <p>如果您已经向卖家付款，请千万不要取消交易。</p>
                <span style="color: #747E89">取消规则：</span>
                <p>
                    买方当日连续取消3笔，将会限制当日买入功能
                </p>
            </div>
        </van-dialog>
        <!-- 支付方式选择 -->
        <van-action-sheet v-model="showPayType">
            <div class="payContentChoose">
                <ul class="radio-box">
                    <li @click="choose(1)" v-if="this.orderObj.bank">
                        <input type="radio" name="radioName" id="fed-engineer"
                               :checked="radio===1" hidden>
                        <label for="fed-engineer"></label>
                        <span><img :src="yl_active" alt="" class="bank">银行卡</span>
                    </li>
                    <li @click="choose(2)" v-if="this.orderObj.alipay">
                        <input type="radio" name="radioName" id="bed-engineer"
                               :checked="radio===2" hidden>
                        <label for="bed-engineer"></label>
                        <span><img :src="ali_active" alt="" class="ali">支付宝</span>
                    </li>
                    <li @click="choose(3)" v-if="this.orderObj.weixin">
                        <input type="radio" name="radioName" id="fsd-engineer"
                               :checked="radio===3" hidden>
                        <label for="fsd-engineer"></label>
                        <span><img :src="wx_active" alt="" class="wx">微信</span>
                    </li>
                </ul>
                <button @click="showPayType=false">取消</button>
            </div>
        </van-action-sheet>
        <!-- 二维码 -->
        <van-popup v-model="erCodeShow" style="background:transparent;border-radius: 10px;">
            <div class="erCodeWrap">
                <img src="../../assets/img/close.png" alt="" class="closeBtn" @click="erCodeShow=false"/>
                <div class="imgWrap" v-if="erCodeUrl">
                    <img :src="erCodeUrl" alt="">
                </div>
                <button @click="saveImg">保存二维码</button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Header from "../../components/header";
    // 微信图片
    import wx_active from "@/assets/img/c2c/wx_active@3x.png"
    // 支付宝图片
    import ali_active from "@/assets/img/c2c/ali_active@3x.png"
    // 银联图片
    import yl_active from "@/assets/img/c2c/yl_active@3x.png"

    export default {
        name: "c2cOrder",
        components: {
            Header
        },
        data() {
            return {
                show: false,
                orderObj: {},
                showPayType: false,
                erCodeShow: false,
                radio: 1,
                wx_active,
                ali_active,
                yl_active,
                // 二维码弹框
                erCodeUrl: null,
            }
        },
        created() {
            this.getOrderData();
        },
        methods: {
            getOrderData() {
                let id = this.$route.query.id;
                this.ajax.post('appapi/c2c/order', {id: id}).then((res) => {
                    if (res.data.code === 1) {
                        this.orderObj = res.data.data.info;
                        // 类型选择默认值
                        if (this.orderObj.bank) {
                            this.radio = 1;
                        } else if (this.orderObj.alipay) {
                            this.radio = 2;
                        } else {
                            this.radio = 3;
                        }
                    }
                })
            },
            // 取消订单
            cancelOrderEvent() {
                let id = this.$route.query.id;
                this.ajax.post('appapi/c2c/cancel_order', {id: id}).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.$router.go(0);
                    }
                })
            },
            // 已付款
            readyPay() {
                this.$dialog.confirm({
                    message: '是否确认已付款/n恶意点击将直接冻结账户'
                }).then(() => {
                    let id = this.$route.query.id;
                    this.ajax.post('appapi/c2c/payment', {
                        oid: id,
                        adid: this.orderObj.adid
                    }).then((res) => {
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            this.$router.go(0);
                        }
                    })
                }).catch(() => {
                });
            },
            // 确认收款
            confirmPay() {
                this.$dialog.confirm({
                    message: '是否确认收款'
                }).then(() => {
                    let id = this.$route.query.id;
                    this.ajax.post('appapi/c2c/confirm', {
                        oid: id,
                        adid: this.orderObj.adid
                    }).then((res) => {
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            this.$router.go(0);
                        }
                    })
                }).catch(() => {
                });
            },
            // 前往聊天页
            toMsgPage() {
                let id = this.$route.query.id;
                this.$router.push({path: "/chatView", query: {id: id}});
            },
            // 前往申诉也
            toComplain() {
                let id = this.orderObj.id;
                let adid = this.orderObj.adid;
                this.$router.push({path: "/allege", query: {id: id, adid: adid}});
            },
            // 进入评价页(完成页)
            toComplete() {
                let id = this.orderObj.id;
                this.$router.push({path: "/complete", query: {id: id}});
            },
            // 选择支付方式
            choose(index) {
                this.radio = index;
                this.showPayType = false;
                switch (index) {
                    case 2:
                        this.erCodeShow = true;
                        this.erCodeUrl = this.imgBaseUrl + this.orderObj.alipay.code;
                        break;
                    case 3:
                        this.erCodeShow = true;
                        this.erCodeUrl = this.imgBaseUrl + this.orderObj.weixin.code;
                        break;
                }
            },
            // 保存图片
            saveImg() {
                let a = document.createElement("a");
                a.download = "pic";
                a.href = this.imgBaseUrl + this.erCodeUrl;
                a.click();
            },
            showPhoneNum() {
                this.$dialog.alert({
                    message: this.orderObj.user_tel
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    #c2cOrder {
        min-height: 100vh;

        .bgImg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
        }

        .header {
            position: relative;
            z-index: 10;
            background: transparent !important;
        }

        .content {
            position: relative;
            z-index: 10;
            padding: 0 30px;
        }

        .topWrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px 0 17px;
            margin: 20px 0 60px;

            div {
                display: flex;
                flex-direction: column;

                span {
                    font-size: 30px;
                    color: rgba(255, 255, 255, 1);
                    opacity: 0.8;

                    &:first-child {
                        font-size: 40px;
                        font-weight: bold;
                        color: rgba(255, 255, 255, 1);
                    }
                }
            }

            img {
                width: 144px;
                height: 155px;
            }
        }

        .orderInfo {
            padding: 30px;
            margin-bottom: 30px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;

            .infoList {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 35px;

                &:last-child {
                    margin-bottom: 0;
                }

                .type {
                    font-size: 26px;
                    font-weight: bold;
                }

                .padding {
                    color: #FF932A;
                }

                .success {
                    color: #1FC26D;
                }


                .left {
                    span {
                        display: inline-block;
                        font-size: 26px;
                        font-weight: bold;
                        color: rgba(119, 119, 119, 1);
                        line-height: 20px;

                        &:first-child {
                            width: 120px;
                        }

                        &:last-child {
                            margin-left: 10px;
                            color: #1FC26D;
                        }
                    }
                }
            }
        }

        .payType {
            display: flex;
            align-items: center;
            padding: 30px;
            margin-bottom: 30px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;

            img {
                width: 88px;
                height: 88px;
                opacity: 0.8;
                border-radius: 50px;
            }

            div {
                display: flex;
                flex-direction: column;
                margin-left: 29px;

                span {
                    font-size: 30px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);

                    &:last-child {
                        margin-top: 22px;
                        font-size: 26px;
                    }
                }
            }
        }

        .codeBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 38px 30px;
            margin-bottom: 30px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;

            span {
                font-size: 26px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 20px;

                &:last-child {
                    color: #FF3052;
                }
            }
        }

        .topicBox {
            padding: 32px 50px 32px 28px;
            margin-bottom: 16px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
            border-radius: 20px;

            .title {
                font-size: 26px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 35px;
            }

            .topicList {
                p {
                    font-size: 24px;
                    font-weight: 500;
                    color: rgba(119, 119, 119, 1);
                    margin-bottom: 32px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    span {
                        color: #DF5334;
                    }
                }
            }
        }

        .footBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(239, 240, 241, 1);

            .left {
                display: flex;
                align-items: center;
                margin-right: 50px;

                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin-right: 50px;

                    &:last-child {
                        margin-right: 0;
                    }

                    img {
                        width: 38px;
                        height: 38px;
                        margin-bottom: 11px;
                    }

                    span {
                        font-size: 20px;
                        color: rgba(18, 18, 18, 1);
                    }
                }
            }

            .right {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;

                button {
                    flex: 1;
                    height: 64px;
                    margin-right: 15px;
                    border-radius: 32px;
                    font-size: 26px;
                    font-weight: bold;
                    color: rgba(18, 18, 18, 1);
                    border: 2px solid #E3E4E6;

                    &:last-child {
                        margin-right: 0;
                    }
                }

                .success {
                    background: rgba(31, 194, 109, 1);
                    font-size: 26px;
                    color: rgba(255, 255, 255, 1);
                }

                .cancel {
                    background: #BABABA;
                    font-size: 26px;
                    color: rgba(255, 255, 255, 1);
                }
            }
        }

        .cancelAlert {
            padding: 30px;

            p {
                margin-bottom: 30px;
                font-size: 24px;
                font-weight: 500;
                color: rgba(116, 126, 137, 1);
            }

            span {
                margin-bottom: 10px;
                font-size: 24px;
                font-weight: 500;
                color: rgba(116, 126, 137, 1);
            }
        }

        .payContentChoose {
            padding: 0 35px 25px;

            .radio-box {
                display: flex;
                flex-direction: column;
            }

            .radio-box li {
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: row-reverse;
                height: 95px;
                border-bottom: 1px solid rgba(157, 157, 157, .1);


                &:last-child {
                    border: none;
                }
            }

            .radio-box li:first-child {
                margin-left: 0;
            }

            .radio-box input:checked + label {
                background-color: #1FC26D;
            }

            .radio-box label {
                margin-right: 10px;
                padding: 6px;
                border: 1px solid #E5E5E5;
                border-radius: 100%;
                width: 28px;
                height: 28px;
                background-clip: content-box;
                cursor: pointer;
                transition: all 300ms;
            }

            .radio-box label:hover {
                border-color: #1FC26D;
                background-color: #1FC26D;
                box-shadow: 0 0 2px #1FC26D;
            }

            .radio-box span {
                display: flex;
                align-items: center;
                height: 100%;
                font-size: 32px;
                color: rgba(51, 51, 51, 1);

                .bank {
                    width: 57px;
                    height: 36px;
                    margin-right: 28px;
                }

                .ali {
                    width: 40px;
                    height: 40px;
                    margin-right: 37px;
                }

                .wx {
                    width: 41px;
                    height: 36px;
                    margin-right: 37px;
                }
            }

            button {
                width: 100%;
                height: 80px;
                font-size: 32px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                line-height: 60px;
                background: rgba(31, 194, 109, 1);
                border-radius: 40px;
            }
        }

        .erCodeWrap {
            position: relative;
            width: 560px;
            height: 735px;
            margin: 40px;
            padding: 50px 70px 30px;
            background: url("../../assets/img/erCodeBg.png") no-repeat center/cover;
            z-index: 1500;

            .closeBtn {
                position: absolute;
                right: -20px;
                top: -20px;
                width: 47px;
                height: 47px;
                z-index: 2000;
            }

            .imgWrap {
                width: 100%;
                height: 551px;
                padding: 25px;
                margin-bottom: 20px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            button {
                width: 100%;
                height: 70px;
                border-radius: 10px;
                font-size: 30px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                background: rgba(31, 194, 109, 1);
            }
        }
    }
</style>
